// extracted by mini-css-extract-plugin
module.exports = {"loader_style":"OpenAsgFromMail_loader_style__389Nu"};